import arrowToggle from './by-type/arrowToggle';
import checkbox from './by-type/checkbox';
import checkboxGroup from "./by-type/checkboxGroup";
import date from './by-type/date';
import dateToDate from './by-type/dateToDate';
import leftRightSelect from './by-type/leftRightSelect';
import ajaxLeftRightSelect from "./by-type/ajaxLeftRightSelect";
import leftRightGroupableSelect from './by-type/leftRightGroupableSelect';
import singleSelect from './by-type/singleSelect';
import multiSelect from './by-type/multiSelect';
import singleSearchableSelect from './by-type/singleSearchableSelect';
import multiSearchableSelect from './by-type/multiSearchableSelect';
import singleAjaxSelect from './by-type/singleAjaxSelect';
import multiAjaxSelect from './by-type/multiAjaxSelect';
import number from './by-type/number';
import pillbox from './by-type/pillbox';
import radioGroup from './by-type/radioGroup';
import text from './by-type/text';
import time from './by-type/time';
import timeToTime from './by-type/timeToTime';
import CustomFormExtendable from "../CustomFormExtendable";

export default function getInputComponent(type, props) {
    switch (type) {
        case 'text': return text(props);
        case 'number': return number(props);
        case 'checkbox': return checkbox(props);
        case 'checkboxGroup': return checkboxGroup(props);
        case 'arrowToggle': return arrowToggle(props);
        case 'singleSelect': return singleSelect(props);
        case 'multiSelect': return multiSelect(props);
        case 'singleSearchableSelect': return singleSearchableSelect(props);
        case 'multiSearchableSelect': return multiSearchableSelect(props);
        case 'singleAjaxSelect': return singleAjaxSelect(props);
        case 'multiAjaxSelect': return multiAjaxSelect(props);
        case 'leftRightSelect': return leftRightSelect(props);
        case 'ajaxLeftRightSelect': return ajaxLeftRightSelect(props);
        case 'leftRightGroupableSelect': return leftRightGroupableSelect(props);
        case 'radioGroup': return radioGroup(props);
        case 'pillbox': return pillbox(props);
        case 'date': return date(props);
        case 'dateToDate': return dateToDate(props);
        case 'time': return time(props);
        case 'timeToTime': return timeToTime(props);
    }

    return CustomFormExtendable.getInputComponent(type, props);
}

function normalizeValue(value, type) {
    switch (type) {
        case 'text':
            return String(value || '');
        case 'number':
            return value === '' || value === null || isNaN(value) ? null : Number(value);
        case 'singleSelect':
        case 'singleSearchableSelect':
        case 'singleAjaxSelect':
            return value === undefined || value === null ? null : value;
        case 'multiSelect':
        case 'multiSearchableSelect':
        case 'multiAjaxSelect':
            return value || [];
        case 'pillbox':
            return value || [];
        case 'leftRightSelect':
            return value || [];
        case 'ajaxLeftRightSelect':
            return value || [];
        case 'leftRightGroupableSelect':
            return value || [];
        case 'checkbox':
            return !!value;
        case 'checkboxGroup':
            return value || [];
        case 'arrowToggle':
            return !!value;
        case 'radioGroup':
            return value === undefined || value === null ? null : value;
        case 'dateToDate':
            return value instanceof Array && value.length === 2
                ? value.map(item => item || [null, null, null])
                : [[null, null, null], [null, null, null]];
        case 'timeToTime':
            return value instanceof Array && value.length === 2
                ? value.map(item => item || [null, null, null])
                : [[null, null, null], [null, null, null]];
    }

    return CustomFormExtendable.normalizeValue(value, type);
}

export {
    normalizeValue
}
